export const apiUrl = process.env.API_HOST;
// export const gViewURL = 'http://170.64.190.76:1340';
// export const pspDleUrl = 'http://170.64.190.76:1350';
export const MAIN_WEBSITES = 'pointshareglobe.com,pointshareplus.com,pointsharecloud.com';

export const USER_SAVE_NAME = 'USER SAVE';

export const OLD_AUTO_SAVE_NAME = 'AUTO-SAVE';

export const ColourBands = {
    Range_25mm: [
        -0.2, -0.175, -0.175, -0.15, -0.15, -0.125, -0.125, -0.1, -0.1, -0.075, -0.075, -0.05, -0.05, -0.025, -0.025,
        0.025, 0.025, 0.05, 0.05, 0.075, 0.075, 0.1, 0.1, 0.125, 0.125, 0.15, 0.15, 0.175, 0.175, 0.2,
    ],
    Range_50mm: [
        -0.4, -0.35, -0.35, -0.3, -0.3, -0.25, -0.25, -0.2, -0.2, -0.15, -0.15, -0.1, -0.1, -0.05, -0.05, 0.05, 0.05,
        0.1, 0.1, 0.15, 0.15, 0.2, 0.2, 0.25, 0.25, 0.3, 0.3, 0.35, 0.35, 0.4,
    ],
    Range_100mm: [
        -0.8, -0.7, -0.7, -0.6, -0.6, -0.5, -0.5, -0.4, -0.4, -0.3, -0.3, -0.2, -0.2, -0.1, -0.1, 0.1, 0.1, 0.2, 0.2,
        0.3, 0.3, 0.4, 0.4, 0.5, 0.5, 0.6, 0.6, 0.7, 0.7, 0.8,
    ],
    Colours: [
        0, 0, 0, 102, 0, 102, 153, 0, 204, 51, 51, 204, 0, 102, 255, 0, 153, 255, 50, 206, 176, 74, 210, 74, 118, 255,
        33, 204, 255, 102, 255, 255, 0, 255, 153, 51, 255, 102, 0, 255, 0, 0, 204, 0, 0,
    ],
};
